import React, { useState, useEffect } from "react"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { Step, StepOption } from "../../../types/wizard"
import { wizardStore } from "../../../stores/wizard"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function useDebouncedSearch(onChange: (filterResult: StepOption[]) => void, step?: Step) {
  const [searchString, setSearchString] = useState('')
  const [searchNotFound, setSearchNotFound] = useState('')

  useEffect(() => {
    const handler = setTimeout(() => {
      const options = step?.options ?? wizardStore.step.options;
      const filterResult = options?.filter((opt) =>
        opt.name.toLowerCase().includes(searchString.toLowerCase())
      )
      const displayTitle = step?.title ?? wizardStore?.step.title;

      if (!filterResult.length) {
        setSearchNotFound(`No ${displayTitle} were found with this criteria`)
      } else {
        setSearchNotFound('')
      }

      onChange(filterResult)
    }, 300)

    return () => clearTimeout(handler)
  }, [searchString, onChange, step])

  return { setSearchString, searchNotFound, searchString }
}

/**
 * Filter Slider thumbnails
 * @param onChange 
 * @returns 
 */
export default function SearchBoxOptions({ onChange, placeHolder = "Search...", step }: { placeHolder?: string; onChange: (filterResult: StepOption[]) => void; step?: Step }) {
  const inputRef = React.useRef<HTMLInputElement>(null)
  const { setSearchString, searchNotFound, searchString } = useDebouncedSearch(onChange, step)

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchString(event.target.value)
  }

  const handleSearchIcon = () => inputRef.current?.focus()

  return (
    <div className="mt-2 mb-6 w-full">
      <div className="flex items-center justify-center p-1 relative rounded bg-white border border-solid border-[rgb(204,204,204)]">
        <FontAwesomeIcon onClick={handleSearchIcon} icon={faSearch} />
        <input
          ref={inputRef}
          className="w-full focus:outline-none p-2"
          onChange={handleSearch}
          placeholder={placeHolder}
          type="text"
          value={searchString}
        />
      </div>
      {searchNotFound ? <p className="absolute text-xs text-error font-bold text-left mt-1 ml-1">{searchNotFound}</p> : null}
    </div>
  )
}